import React, { useEffect, useState } from 'react';
import { useCaptions } from '@/context/caption-context/use-captions';
import { useAuth } from "@/context/auth-context/use-auth.ts";
import { UserPlan } from "@/models";
import { API_BASE } from "@/config.ts";

const captionTimeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

function formatCaptionTime(timestamp: number) {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return captionTimeFormatter.format(date);
}

type CaptionOverlayProps = {
  plan?: UserPlan | null;
}

export function CaptionOverlay({plan}: CaptionOverlayProps) {
  const { feed, captionLine, captionsEnabled } = useCaptions();

  if (plan === UserPlan.FREE) return;

  if (!captionsEnabled) return null;
  if (feed.length === 0 && !captionLine) return null;

  return (
    <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-50 flex w-full max-w-3xl max-h-[60vh] flex-col justify-end items-center gap-2 px-4 pointer-events-none overflow-hidden">
      <div className="flex w-full flex-col items-end gap-1.5">
        {feed.map((item) => (
          <div
            key={item.id}
            className="bg-black/60 text-white/90 px-3 py-2 rounded-md text-sm max-w-full text-right backdrop-blur-sm shadow-md transition-all duration-300 break-words"
          >
            <time
              dateTime={new Date(item.timestamp).toISOString()}
              className="mr-2 align-baseline text-[10px] font-normal tracking-wide text-white/30 tabular-nums select-none"
            >
              {formatCaptionTime(item.timestamp)}
            </time>

            <span className="font-semibold text-blue-300/90 mr-2">{item.speaker}:</span>

            <span className="text-white/90 whitespace-pre-wrap break-words">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
